// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OutletEditor_wrapper__2uuCR","coordsWraper":"OutletEditor_coordsWraper__3wnov","shadow":"OutletEditor_shadow__1LkPn"};